export default __webpack_public_path__ + "static/media/add_more_moments.d1df35ba.svg";